import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { getFormattedPrice } from '../../service/FormatHelpers/FormatHelpers';
import { BannerPrice, PrefixPrice } from '../../typings/banners';

import './BannerPriceInfo.css';
import * as keyset from './BannerPriceInfo.i18n';

const i18n = i18nFactory(keyset);

export interface BannerPriceInfoProps {
    bannerPrice: BannerPrice;
    isColumn?: boolean;
}

const BLOCK = 'banner-price-info';

export class BannerPriceInfo extends React.PureComponent<BannerPriceInfoProps> {
    render() {
        const { bannerPrice, isColumn } = this.props;

        return bannerPrice.price ? (
            <span
                className={Bem.cls({
                    block: BLOCK,
                    mods: { column: Boolean(isColumn) }
                })}
            >
                <span>
                    {this.getPrefix()}
                    {this.getPrice('price')}
                </span>
                {bannerPrice.priceOld ? this.getPrice('priceOld') : null}
            </span>
        ) : (
            <span className={classNames(Bem.cls(BLOCK))}>
                {i18n('empty-price')}
            </span>
        );
    }

    private getPrice(value: string) {
        const { bannerPrice } = this.props;

        return (
            <span className={Bem.cls(BLOCK, value)}>
                {`${getFormattedPrice(
                    bannerPrice[value]
                )} ${mapStringToCurrencySymbol(bannerPrice.currency)}`}
            </span>
        );
    }

    private getPrefix() {
        const { bannerPrice } = this.props;

        let text: string;
        switch (bannerPrice.prefix) {
            case PrefixPrice.FROM:
                text = i18n('from');
                break;
            case PrefixPrice.TO:
                text = i18n('to');
                break;
            default:
                return;
        }

        return <span className={Bem.cls(BLOCK, 'prefix')}>{`${text} `}</span>;
    }
}
